import React from "react";

function ToBeTicketQueues() {
  return <div>ToBeTicketQueues</div>;
}

export default ToBeTicketQueues;
